import { Spin } from "antd";
import { type ReactNode, Suspense } from "react";

/** 路由懒加载时的统一 fallback */
export const RouteSuspense = ({ children }: { children: ReactNode }) => (
  <Suspense
    fallback={
      <div className="flex min-h-[200px] w-full items-center justify-center py-16">
        <Spin />
      </div>
    }
  >
    {children}
  </Suspense>
);
